import { Routes } from '@angular/router';

export const USER_ROUTES: Routes = [
	{
		path: 'customer',
		loadComponent: () => import('./feature-customer/customer').then((m) => m.Customer),
		data: { title: 'Usuarios' },
	},
];
